module.exports = __webpack_public_path__ + "img/logo.d26ab890.jpg";